export default "__VITE_ASSET__UxDDRSLR__"